import { $$, on, setCookie, getCookie } from "../../utils/dom";

export const onContentLoaded = (): void => {
  const closeButtons = $$(".js-alertMessage__close");

  const handleCloseAlert = (
    key: string,
    value: string,
    messageContainer: HTMLElement
  ) => {
    if (process.env.NODE_ENV === "production") setCookie(key, value);

    return messageContainer.classList.add("is-hidden");
  };

  if (closeButtons) {
    closeButtons.forEach((button: HTMLElement) => {
      const { lang = "sv", sysMess, isCookie } = button.dataset;

      const messageContainer: HTMLElement =
        (button.closest(".js-alertMessage") as HTMLElement) ||
        button.parentElement?.parentElement;

      if (isCookie) {
        const isCookieSet = getCookie("cookie-consent-is-given");

        if (isCookieSet) {
          messageContainer.classList.add("is-hidden");
          return;
        }

        messageContainer?.classList.remove("is-hidden");

        return (button.onclick = () =>
          handleCloseAlert(
            "cookie-consent-is-given",
            "true",
            messageContainer
          ));
      }

      if (sysMess) {
        const closedMessage = getCookie(lang);

        if (closedMessage === sysMess) return;

        messageContainer?.classList.remove("is-hidden");

        return (button.onclick = () =>
          handleCloseAlert(lang, sysMess, messageContainer));
      }

      return (button.onclick = () => messageContainer?.remove());
    });
  }
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
